import { render, staticRenderFns } from "./fillPreQuiz.vue?vue&type=template&id=84eaf4a8&scoped=true"
import script from "./fillPreQuiz.vue?vue&type=script&lang=js"
export * from "./fillPreQuiz.vue?vue&type=script&lang=js"
import style0 from "./fillPreQuiz.vue?vue&type=style&index=0&id=84eaf4a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84eaf4a8",
  null
  
)

export default component.exports